import React, { useState, useEffect } from 'react';
import '../../App.css'
import coffeeBeans from '../../assets/coffee-beans.png'
import sicakKahveler from '../../assets/menu/icecekler/sicak-kahveler.png'
import sogukKahveler from '../../assets/menu/icecekler/soguk-kahveler.png'
import sicakIcecekler from '../../assets/menu/icecekler/sicak-icecekler.png'
import sogukIcecekler from '../../assets/menu/icecekler/soguk-icecekler.png'
import kokteyller from '../../assets/menu/icecekler/kokteyller.png'
import mesrubatlar from '../../assets/menu/icecekler/mesrubatlar.png'
import turkKahveleri from '../../assets/menu/icecekler/turk-kahveleri.png'







import Kategori from '../Kategori'
import '../Kategori.css'


const Icecekler = () => {
  const [isPhone, setIsPhone] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsPhone(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);


  
  return (
    isPhone ? (
    <div>   
    <div className="container" style={{marginTop: '20px'}}>
      <img src={coffeeBeans} style={{width: '36px', height: '36px'}} alt="Kahve çekirdekleri" />
      <h2 style={{marginLeft: 'auto', fontWeight: '700' }}>İçecekler</h2>
      
    </div>
    <hr style={{color: '#D8D8D8'}} />
    <div className="kategoriler-list">
        <Kategori ad="Sıcak Kahveler" resim={sicakKahveler} />
        <Kategori ad="Soğuk Kahveler" resim={sogukKahveler} />
        <Kategori ad="Sıcak İçecekler" resim={sicakIcecekler} />
        <Kategori ad="Soğuk İçecekler" resim={sogukIcecekler} />
        <Kategori ad="Kokteyller" resim={kokteyller} />
        <Kategori ad="Türk Kahveleri" resim={turkKahveleri} />
        <Kategori ad="Meşrubatlar" resim={mesrubatlar} />   


      </div>
    </div>
  ) : (
    <div>
      <div>   
    <div className="container" style={{marginTop: '20px'}}>
      <img src={coffeeBeans} style={{width: '36px', height: '36px'}} alt="Kahve çekirdekleri" />
      <h2 style={{marginLeft: 'auto', fontWeight: '700' }}>İçecekler</h2>
      
    </div>
    <hr style={{color: '#D8D8D8'}} />
    <div className="kategoriler-list-computer">
        <Kategori ad="Sıcak Kahveler" resim={sicakKahveler} />
        <Kategori ad="Soğuk Kahveler" resim={sogukKahveler} />
        <Kategori ad="Sıcak İçecekler" resim={sicakIcecekler} />
        <Kategori ad="Soğuk İçecekler" resim={sogukIcecekler} />
        <Kategori ad="Kokteyller" resim={kokteyller} />
        <Kategori ad="Türk Kahveleri" resim={turkKahveleri} />
        <Kategori ad="Meşrubatlar" resim={mesrubatlar} />   


      </div>
    </div>
    </div>
  )
  )
}

export default Icecekler 